import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    fontSizes,
    fontWeights,
    colors,
    gutterSizes,
    boxSizes,
    colorVariables,
} from '@gumtree/ui-library/src/base/theme';
import { Button } from '@gumtree/ui-library';

const baseStyles = css`
    box-sizing: border-box;
`;

export const DropdownContainer = styled.div`
    ${baseStyles};
    position: relative;
`;

export const TriggerButton = styled.button`
    ${baseStyles};
    width: 100%;
    height: 36px;
    padding: 8px 12px;
    background-color: transparent;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s;
    border: none;
    color: ${colors.blade};
    .label {
        font-size: ${fontSizes.small};
        font-weight: ${fontWeights.bold};
        letter-spacing: 0.13px;
        padding: 0 ${gutterSizes.base};
    }
    .icon {
        font-size: ${fontSizes.smaller};
    }
    &:hover {
        background-color: ${colors.bark10};
    }

    &.active {
        outline: none;
        background-color: ${colors.white};
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
    }
`;

// 下拉菜单样式
export const DropdownMenu = styled.ul`
    ${baseStyles};
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: 10px 0 0;
    width: 340px;
    max-height: 492px;
    list-style: none;
    background-color: ${colors.white};
    border: 1px solid #e0e0e0;
    border-radius: ${boxSizes.borderRadius4};
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
    z-index: 100;
    overflow-y: auto;
`;

// 菜单项样式
export const MenuItem = styled.li`
    ${baseStyles};
    height: 48px;
    padding: ${gutterSizes.large};
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: ${fontSizes.base};
    color: ${colorVariables.textHighlightedDescription};
    font-weight: 330;
    .check-box {
        color: ${colors.white};
        display: flex;
        width: 16px;
        height: 16px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 2px solid ${colors.bark20};
    }
    .icon {
        font-size: ${fontSizes.smaller};
        margin-left: 6px;
    }
    &.active {
        .check-box {
            background-color: ${colorVariables.textHighlightedDescription};
            border-color: ${colorVariables.textHighlightedDescription};
        }
    }
`;

export const SelectFooter = styled.div`
    ${baseStyles};
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    left: 0;
    bottom: 0;
    padding: 16px;
    background-color: ${colors.white};
    border-top: 1px solid ${colorVariables.borderLighter};
`;

export const ApplyButton = styled(Button)`
    width: 205px;
    justify-content: center;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    letter-spacing: 0.15px;
    color: ${colorVariables.textHighlightedDescription};
`;
export const ClearButton = styled(ApplyButton)`
    width: 90px;
`;
